module.exports = "/_next/static/images/bukalapak_ic-804717ed401e02356562c1dcb99acf8d.svg";